<template>
  <div>
    <b-button
      style="margin-bottom: 10px;"
      variant="primary"
      @click="allPechat"
      class="navbarBtnTashxis"
    >
      <b-icon icon="printer-fill"></b-icon>
      Печать
    </b-button>
    <div style="display: flex; flex-wrap: wrap;">
      <div
        class="stat-bemor-text"
        style="width: 700px; margin-top: 10x; margin-left: 10px;"
        v-for="(item, index) in selectShablonJson"
        :key="index"
      >
        <div style="display: flex; justify-content: space-between;">
          <div style="display: flex;">
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3 mr-2"
              v-b-modal="'modal-shablon' + 'kundalik' + index + modalIdCom"
              @click="getShablonDoctor('kundalik')"
            >
              <b-icon icon="arrow-down-circle-fill"></b-icon>
            </b-button>

            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3"
              v-b-modal="'modal-new-shab-creat-kundalik' + index + modalIdCom"
            >
              <b-icon icon="arrow-up-circle-fill"></b-icon>
            </b-button>
            <b-form-checkbox
              style="display: flex; margin-left: 10px;"
              size="lg"
              @change="addPechat($event, item)"
              :value="true"
              :unchecked-value="false"
            >
            </b-form-checkbox>
            <input
              type="number"
              class="input-stile mb-3 ml-2"
              style="width: 100px;"
              @input="textChange"
              v-model="item.number"
            />
          </div>
          <b-button
            style="margin-left: 10px; width: 35px; height: 35px; display: flex; justify-content: center;"
            @click="deleteKundalik(index)"
            variant="outline-danger"
          >
            <b-icon style="width: 17px;" icon="trash"></b-icon>
          </b-button>
        </div>
        <b-modal
          :id="'modal-shablon' + 'kundalik' + index + modalIdCom"
          size="lg"
          :title="$t('Шаблонлар рўйхати')"
          hide-footer
        >
          <Shablon
            :modalIdCom="modalIdCom"
            :plus_dont_show="true"
            :indRegShif="index"
            :shabType="'kundalik'"
            :itemsShablon="itemsShablon"
            @ShablonGet="getShablon"
            @RowClickedShab="RowClickedShab"
          />
        </b-modal>

        <b-modal
          :id="'modal-new-shab-creat-kundalik' + index + modalIdCom"
          :title="$t('Шифокор шаблон')"
          hide-footer
        >
          <div>
            <div>
              <b-input type="text" v-model="name"></b-input>
            </div>
          </div>
          <div class="CreateName">
            <b-button
              class="modalBtn1"
              size="sm"
              style="height: 37px;"
              variant="danger "
              @click="ShifokorShablonClose"
            >
              <b-icon icon="calendar2-x"></b-icon>
              {{ $t("Бекор қилиш") }}
            </b-button>
            <b-button
              class="mt-3 ml-2 modalBtn"
              @click="ShifokorShablon(index)"
              variant="success"
            >
              <b-icon icon="calendar2-plus"></b-icon>
              {{ $t("Сақлаш") }}
            </b-button>
          </div>
        </b-modal>
        <label>Sana </label>

        <input
          type="date"
          class="input-stile"
          @input="textChange"
          v-model="item.day"
        />

        <textarea
          rows="10"
          @input="textChange"
          v-model="item.text"
          style="width: 100%; height: 400px;"
        ></textarea>

        <label>Shifokor</label>
        <input
          class="input-stile"
          type="text"
          @input="textChange"
          v-model="item.doctor"
          style="width: 400px;"
        />
      </div>
      <b-button
        class="qoshish_Btn"
        variant="primary"
        type="number"
        @click="add"
      >
        <b-icon icon="plus" font-scale="2" color="#fff"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import Shablon from "../Shifokor/Shablon.vue";
export default {
  props: ["statsionar_text", "modalIdCom"],
  components: {
    Shablon
  },
  data() {
    return {
      options: [],
      name: "",
      datas: {
        id: 0,
        name: "",
        status: ""
      },
      number: 0,
      itemsShablon: [],
      pechat: [],
      selectShablonJson: [],
      itemShablon: [],
      status: "",
      ValueSelect: ""
    };
  },
  created() {
    if (this.statsionar_text == "" || !this.statsionar_text) {
      this.selectShablonJson = [
        { day: "", text: "", doctor: "", key: new Date().getTime() }
      ];
    } else {
      this.selectShablonJson = JSON.parse(this.statsionar_text.toString());
    }
  },
  watch: {
    statsionar_text(newVal, old) {
      this.selectShablonJson = JSON.parse(newVal.toString());
    }
  },
  methods: {
    allPechat() {
      let t = {};
      if (this.pechat.length) {
        t = {
          value: this.pechat
        };
      } else {
        t = {
          value: JSON.parse(this.statsionar_text.toString())
        };
      }
      localStorage.setItem("kundalik", JSON.stringify(t));
      const rout = this.$router.resolve({
        path: "/user-kundalik"
      });
      window.open(rout.href, "_blank");
    },
    addPechat(value, item) {
      if (value) {
        this.pechat.push(item);
      } else {
        let x = this.pechat.findIndex(el => el.key == item.key);
        if (x != -1) {
          this.pechat.splice(x, 1);
        }
      }
    },
    ShifokorShablonClose() {
      this.name = "";
      this.$bvModal.hide(
        `${"modal-new-shab-creat-kundalik" + this.modalIdCom}`
      );
    },
    RowClickedShab($events, ind) {
      let text = JSON.parse($events.text.toString());
      this.selectShablonJson[ind].text = text;
      this.textChange();
      this.$bvModal.hide(
        `${"modal-shablon" + "kundalik" + ind + this.modalIdCom}`
      );
    },
    deleteKundalik(index) {
      this.selectShablonJson.splice(index, 1);
      this.textChange();
    },
    getShablonDoctor(key) {
      let self = this;
      self.status = key;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: JSON.parse(localStorage.getItem("user")).id,
          doc_type: key
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    ShifokorShablon(index) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: {
          name: self.name,
          text: JSON.stringify(self.selectShablonJson[index].text).toString(),
          doctor_id: JSON.parse(localStorage.getItem("user")).id,
          doc_type: "kundalik"
        }
      }).then(res => {
        if (res) {
          self.$bvModal.hide(
            `${"modal-new-shab-creat-kundalik" + index + self.modalIdCom}`
          );
        }
      });
    },
    textChange() {
      this.$emit(
        "statsionar_text_change",
        JSON.stringify(this.selectShablonJson).toString(),
        "kundalik"
      );
    },
    add() {
      this.selectShablonJson.push({
        day: "",
        text: "",
        doctor: ""
      });
      this.textChange();
    },
    plusClick() {
      this.datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    setStatus($events) {
      if ($events.keyCode == 45 || $events == 45) {
        this.datas = {
          name: this.ValueSelect,
          status: this.status
        };
        this.$bvModal.show("modal-shab-select-create" + this.modalIdCom);
      }
    },
    selectKey(key) {
      this.status = key;
      this.getShablon(key);
    },
    getShablon(status) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_select/shablonOne",
        data: { status: status }
      }).then(res => {
        if (res) {
          self.itemShablon = res.data.data;
        }
      });
    },
    userLink(item) {
      this.datas = item;
      this.$bvModal.show("modal-shab-select-create" + this.modalIdCom);
    },
    trash(id) {
      let self = this;
      axios({
        method: "delete",
        url: "/shablon_select/delete/" + id
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          // self.$bvModal.hide('modal-shab-select-create-text' + self.index + self.modalIdCom);
        }
      });
    },
    ValueSelChange() {
      let value = JSON.stringify(this.statsionar_text);
      // console.log(this.statsionar_text, value);
      this.$emit("selectSablon", value, this.index);
      // this.shablonData = JSON.stringify(this.statsionar_text)
    },
    ValueSel(e) {
      this.ValueSelect = e;
      // salommmmmmmm
    },
    Shablon() {
      let self = this;
      let method = "";
      let url = "";
      if (this.datas.id) {
        method = "patch";
        url = "/shablon_select/update/" + self.datas.id;
      } else {
        self.datas.status = self.status;
        method = "post";
        url = "/shablon_select/create";
      }
      axios({
        method: method,
        url: url,
        data: self.datas
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          self.$bvModal.hide("modal-shab-select-create" + self.modalIdCom);
          self.datas = {
            id: 0,
            name: "",
            status: ""
          };
        }
      });
    },
    Close() {
      datas = {
        id: 0,
        name: "",
        status: ""
      };
    }
  }
};
</script>

<style lang="scss">
.stat-bemor-text {
  width: 49.5%;
  padding: 10px;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  label {
    font-family: "Times New Roman", Times, serif;
    margin-top: 5px;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
  }
}
.qoshish_Btn {
  position: absolute;
  right: 40px;
  bottom: 30px;
  /* left: 990px; */
  background: #195fb0;
  /* margin-top: 5px; */
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #195fb0;
  box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
}
.input-stile {
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: "Times New Roman", Times, serif;
  font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
  border-bottom: 1px solid #000;
}
.display-flex {
  display: flex;
}
.btn-select {
  background-color: #fff;
  border: none;
  // border: 1px  solid #000;
  // border-radius: 50%;
  font-size: 14pt;
  font-weight: 700;
  height: 27px;
  width: 27px;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  top: 3px;
  right: 25px;
  color: #6c6868;
  /* left: -50px; */
}
</style>
